import { jsx as v } from "react/jsx-runtime";
import { LabeledSelect as E } from "../../shared/labeled-select/LabeledSelect.component.js";
import { useCallback as y, useMemo as I, useEffect as O } from "react";
import { T as f } from "../../index-DwB8CbmG.js";
import { equalsWhenLowerCased as u } from "../../shared/utils.js";
const _ = (a, l, o) => a === "createType" ? !Object.values(o).some(
  (e) => e.variant === f.TABLE_DATA_CHANGE && e.operation === "INSERT" && u(e.tableId, l.id)
) : a === "updateType" ? !Object.values(o).some(
  (e) => e.variant === f.TABLE_DATA_CHANGE && e.operation === "MODIFY" && u(e.tableId, l.id)
) : a === "deleteType" ? !Object.values(o).some(
  (e) => e.variant === f.TABLE_DATA_CHANGE && e.operation === "REMOVE" && u(e.tableId, l.id)
) : !0, C = (a, l, o) => {
  O(() => {
    l && (a.some(
      (e) => u(e.value, l.value)
    ) || o(null));
  }, [a, l, o]);
}, G = ({
  state: a,
  dispatch: l,
  copies: o,
  apiDeclaration: e,
  declaration: m,
  stepHandler: s
}) => {
  var d;
  const T = y(
    (r) => {
      const n = r == null ? void 0 : r.value;
      n && l({
        type: "PARAMS_UPDATED",
        payload: s.getUpdatedState(a.params, "ofType", n)
      });
    },
    [l, a, s]
  ), p = I(() => {
    var b;
    const r = a.actionType;
    if (!r) return [];
    const n = (b = e.types) == null ? void 0 : b.filter(
      (t) => _(r, t, m.triggers)
    );
    return (n == null ? void 0 : n.map((t) => ({
      value: t.id,
      label: t.name
    })).sort((t, A) => t.label > A.label ? 1 : t.label < A.label ? -1 : 0)) ?? [];
  }, [e.types, m.triggers, a.actionType]), i = s.getOfTypeValue(a.params), c = i ? p.find((r) => u(r.value, i)) : void 0;
  return C(p, c, T), /* @__PURE__ */ v(
    E,
    {
      labelText: o.tableInputLabel,
      placeholder: o.tableInputPlaceholder,
      options: p,
      id: "flowTableOption",
      error: ((d = a.paramErrors) == null ? void 0 : d.ofType) ?? null,
      onChange: T,
      value: c
    }
  );
};
export {
  G as StepFormGenericType
};
